import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Vehicle, VehicleTypeResponse } from '../../../services/http/vehicles/vehicles.interface';
import { VehiclesService } from '../../../services/http/vehicles/vehicles.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../../services/alert/alert.service';
import { AlertType } from '../../../services/alert/alert.interface';
import { FormsModule } from '@angular/forms';
import { LoaderService } from '../../../services/loader/loader.service';
import { Country } from '../../../services/http/countries/countries.interface';
import { CountriesService } from '../../../services/http/countries/countries.service';

@Component({
  selector: 'app-vehicles-edit',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './vehicles-edit.component.html',
  styleUrl: './vehicles-edit.component.scss'
})
export class VehiclesEditComponent implements OnInit {
  vehicle: Vehicle | null = null;
  vehiclesTypes: any[] = [];
  countries: Country[] = [];

  constructor(
    private readonly vehiclesService: VehiclesService,
    private readonly router: Router,
    private readonly alertService: AlertService,
    private readonly activeRoute: ActivatedRoute,
    private readonly loaderService: LoaderService,
    private readonly countriesService: CountriesService
  ) {
    this.vehiclesService.getVehicleTypes().subscribe((data: VehicleTypeResponse) => {
      this.vehiclesTypes = data.registrations;
    });
    this.countriesService.getCountries().subscribe((data) => {
      this.countries = data.countries;
    });
  }

  ngOnInit(): void {
    const plate = this.activeRoute.snapshot.paramMap.get('plate') || '';
    if (plate !== '') {
      this.vehiclesService.getVehicle(plate).subscribe((vehicle: Vehicle) => {
        this.vehicle = vehicle;
      });
    }
  }

  save() {
    if (this.vehicle) {
      this.loaderService.show();
      this.vehiclesService.updateVehicle(this.vehicle).subscribe((success: Vehicle) => {
        this.alertService.setAlert({
          message: $localize`:@@Vehicles.Edit.Updated:Vehículo actualizado correctamente`,
          type: AlertType.Success,
          dismissible: true,
          dismissOnTimeout: 2000
        });
        this.loaderService.hide();
        this.router.navigate(['vehicles', success.vehiclePlate]);
      });
    }
  }

  goBack() {
    this.router.navigate(['vehicles' + this.vehicle?.vehiclePlate]);
  }
}
